module.exports = __webpack_public_path__ + "img/bg.852bae77.png";